var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 15.125H4.125C4.884 15.125 5.5 15.6723 5.5 16.346V35.9012C5.5 36.5777 4.884 37.125 4.125 37.125H1.375C0.616 37.125 0 36.5778 0 35.904V16.346C0 15.6723 0.616 15.125 1.375 15.125Z",
    fill: "#EB2019"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.67 7.48582C22.8525 6.52332 24.585 6.71857 25.52 7.92857C26.4825 9.11107 26.29 10.8436 25.08 11.7786L20.8725 15.1253H41.25C42.7625 15.1253 44 16.3628 44 17.8753C44 19.3878 42.7625 20.6253 41.25 20.6253H28.875C30.393 20.6253 31.625 21.8573 31.625 23.3753C31.625 24.8933 30.393 26.1253 28.875 26.1253H27.5C29.018 26.1253 30.25 27.3573 30.25 28.8753C30.25 30.3933 29.018 31.6253 27.5 31.6253H26.125C27.6375 31.6253 28.875 32.8628 28.875 34.3753C28.875 35.8878 27.6375 37.1253 26.125 37.1253H12.375C10.7278 37.1253 9.25925 36.3746 8.25 35.2196V16.9101L21.67 7.48582Z",
    fill: "#EB2019"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsIcon);
export default __webpack_public_path__ + "static/media/thumbs-icon.fe846b3b20354d22c65464349b6060c2.svg";
export { ForwardRef as ReactComponent };